/**
 * Main JavaScript File
 */

import $ from 'jquery'
import { gsap } from 'gsap'

// Template Parts
import { header } from './template-parts/header/header'
import { footer } from './template-parts/footer/footer'


// ACF Blocks
import { projectsSlider } from './template-parts/blocks/projects-slider'
import { newsSlider } from './template-parts/blocks/news-slider'
import { imagesSlider } from './template-parts/blocks/images-slider'
import { imagesCarousel } from './template-parts/blocks/images-carousel'
import { timelineSlider } from './template-parts/blocks/timeline-slider'

// Components
import { appearence , loaderInit , pageTransitions} from './components/animations/appearence'
import { counterNumbers } from './components/animations/counter-numbers'
import { scrollToTop } from './components/animations/scroll-to-anchor'
import { accordion } from './components/accordion'
import { video } from './components/video'

// Utils
import { readMore } from './utils/readmore'


$('html').css('overflow' , 'hidden');
$(document).ready(function(){
    // Components
    appearence()
    loaderInit()
    pageTransitions()
    accordion()
    counterNumbers()
    projectsSlider()
    newsSlider()
    imagesSlider()
    imagesCarousel()
    timelineSlider()
    scrollToTop()
    readMore()
    video()

    // Template Parts
    header()
    footer()

    // ACF Blocks


    if($('#loader').length && !localStorage.getItem('hasVisited')){
        const loader = gsap.timeline({
            onComplete: function() {
                $("#loader").hide();
            }
        });
        loader.to("#page-transition", {
            opacity: 0,
            duration: 0.1
        }, "step1");
        loader.to("#loader", {
            opacity: 0,
            duration: 0.5
        }, "step1");
        
        setTimeout(function(){
            loader.play();
        } , 1500)
        localStorage.setItem('hasVisited', 'true');
    } else{
        $("#loader").hide();
        const loader = gsap.timeline();
        loader.to("#page-transition", {
            opacity: 0,
            duration: 0.4
        }, "step1");
        loader.play();
    }
    $('html').css('overflow' , 'auto');

})



